import Request from './../request';
import { IFlavourImagesResourceShort } from '../../props/flavours';

// import interfaces

const FlavourImageService = {
  create: async (flavouId: string, data: FormData): Promise<IFlavourImagesResourceShort[]> => {
    try {
      const results = await Request.post(`/api/flavours/${flavouId}/images`, data, 'multipart/form-data');
      return results;
    } catch (e) {
      throw e;
    }
  },
  delete: async (flavouId: string, id: string): Promise<IFlavourImagesResourceShort> => {
    try {
      const results = await Request.delete(`/api/flavours/${flavouId}/images/${id}`);
      return results;
    } catch (e) {
      throw e;
    }
  },
};

export default FlavourImageService;
